import { get, isNil, isUndefined, orderBy } from "lodash"
import BaseAutocomplete, { BaseAutocompleteProps } from "../base/BaseAutocomplete"
import { UseQueryArrayResult } from "../helpers/queryHelper"
import { DefaultAutocompleteType } from "./DefaultAutocompleteType"

export interface ReactQueryAutocompleteProps<T extends DefaultAutocompleteType, Multiple extends boolean>
    extends Omit<BaseAutocompleteProps<T, Multiple>, "options" | "isOptionEqualToValue" | "getOptionLabel" | "loading"> {

    query: UseQueryArrayResult<T>

    displayFieldName: string,
    displayField?: (v: T) => string,

    orderField?: Array<string>,
    orderWay?: Array<"asc" | "desc">

    blacklist?: Array<T>
    whitelist?: Array<T>
}

export const ReactQueryAutocomplete = <T extends DefaultAutocompleteType, Multiple extends boolean>(props: ReactQueryAutocompleteProps<T, Multiple>): JSX.Element => {

    let { whitelist, blacklist, displayFieldName, query, orderField, orderWay, displayField, ...fwdProps } = props

    let getOptionLabel = (option: T) => get(option, displayFieldName)

    if (displayField !== undefined)
        getOptionLabel = displayField

    let data = query.data;

    if (!isUndefined(orderField) && !isUndefined(orderWay))
        data = orderBy(data, [...orderField], [...orderWay])
    else
        data = orderBy(query.data, [displayFieldName], ['asc'])

    if (!isNil(blacklist) && isNil(whitelist) && blacklist.length > 0)
        data = data.filter(d => !blacklist?.some(x => x.id === d.id))

    if (!isNil(whitelist) && isNil(blacklist) && whitelist.length > 0)
        data = data.filter(d => whitelist?.some(x => x.id === d.id))

    return (
        <BaseAutocomplete

            {...fwdProps}

            options={data}

            isOptionEqualToValue={(option, value) => option.id === value.id}

            getOptionLabel={getOptionLabel}

            loading={query.isLoading}
        />
    )
}
